import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import App from "./App";
import Details from "./components/Details/Details";
import "./Main.css";

function Main() {
  return (
    <div>
      <Router>
        <Switch>
          <Route exact path="/" component={App} />
          <Route exact path="/about" component={Details} />
        </Switch>
      </Router>
    </div>
  );
}

export default Main;
